<template>
  <div style="display: flex;flex-direction: column;overflow: auto;height: 100%;max-height: 1000px;" class="table-body1">
    <slot name="top"/>
    <div style="flex: 1;overflow: hidden">
      <el-table
          v-loading="loading"
          ref="table"
          :emptyText="emptyText"
          :data="tableData"
          :stripe="true"
          :border="true"
          :highlight-current-row="true"
          @select="select"
          @select-all="selectAll"
          :cell-style="{'vertical-align': 'top'}"
          style="width: 100%;padding: 5px;overflow: auto;height: 100%"  >
        <slot/>
      </el-table>
    </div>

    <template v-if="enablePage">
      <el-pagination
          background
          :hide-on-single-page="false"
          :page-sizes="[10,20,30,40,50, 100, 200, 300, 400]"
          :page-size="limit"
          @size-change="sizeChange"
          v-model:currentPage="page"
          layout="prev, pager, next , total , sizes , jumper"
          :total="count"/>
    </template>
  </div>
</template>

<script lang="ts" setup>
import qs from "qs";
import lodash from "lodash";
import {computed, onMounted, PropType, reactive, ref, toRefs, watch} from "vue";
import axios from "axios";

const props = defineProps({
  filter: {
    type: Function as PropType<(item: any) => boolean>,
    default: null
  },
  pageSize: {
    type: Number,
    default: 50
  },
  enablePage: {
    type: Boolean,
    default: true,
  },
  url: {
    type: String,
    default: null
  },
  param: {
    type: Object,
    default() {
      return null
    }
  }
});
const {url, param} = toRefs(props);
const emptyText = ref('');
const loading = ref(false);
const data = reactive({data: [], count: -1});
const count = ref(10);
const page = ref(1);
const limit = ref(props.pageSize);
const selection = ref<any[]>([]);

const tableData = computed(() => {
  if (props.filter) {
    return data.data.filter(props.filter)
  } else {
    return data.data;
  }
})


onMounted(() => {
  query();
})

watch(page, (old, nv) => {
  console.log("page change", old, nv)
  query()
})

watch([param, url], lodash.debounce(() => {
      console.log("watch:param or url", param.value)
      page.value = 1;
      query();
    }, 200),
    {deep: true})

function select(selections: any[]) {
  selection.value = selections;
}

function selectAll(selections: any[]) {
  selection.value = selections;
}

function sizeChange(size: number) {
  console.log("sizeChange", size)
  limit.value = size;
  if(page.value==1){
    query();
  }else{
    page.value = 1;
  }
}

function reload() {
  query();
}

function deleteByIndex(index: number) {
  data.data.splice(index, 1);
}

function getData() {
  return data.data
}


const debounceQuery = lodash.debounce(function () {
  query()
}, 100)

function query() {
  if (url?.value) {
    let httpParam = param.value ? {...param.value} : {};
    httpParam.page = page.value;
    httpParam.limit = limit.value;
    loading.value = true;
    axios.post(url.value, qs.stringify(httpParam))
        .then((res) => {
          console.log(res);
          if (res.data.code === 0) {
            data.data = res.data.data;
            if (res.data.count && res.data.count > 0) {
              count.value = res.data.count;
            }
            selection.value = []
            emptyText.value = '暂无数据';
          } else {
            data.data = []
            emptyText.value = res.data.msg;
          }
          loading.value = false;
        }).catch(err => {
      console.log(err);
      loading.value = false
    })
  }
}

defineExpose({
  getData,
  deleteByIndex,
  reload,
  data: data,
  selection: selection,
  query
})

</script>

<style scoped>

</style>
